import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ConfigProvider, Layout, theme } from 'antd'
import esES from 'antd/locale/es_ES'
import Login from './pages/Login'
import ClientPortal from './pages/ClientPortal'
import Dashboard from './pages/Dashboard'
import Clients from './pages/Clients'
import Payments from './pages/Payments'
import Classes from './pages/Classes'
import Attendance from './pages/Attendance'
import WhatsAppConfig from './pages/WhatsAppConfig'
import Usuarios from './pages/Usuarios'
import Rutinas from './pages/Rutinas'
import Objetivos from './pages/Objetivos'
import Progreso from './pages/Progreso'
import Reportes from './pages/Reportes'
import Mensajes from './pages/Mensajes'
import Configuracion from './pages/Configuracion'
import Bienestar from './pages/Bienestar'
import Navbar from './components/Navbar'
import AdminSider from './components/AdminSider'
import PrivateRoute from './components/PrivateRoute'
import { AuthProvider, useAuth } from './context/AuthContext'

const { Content, Footer } = Layout

function AppContent() {
  const { user, loading } = useAuth()
  const location = useLocation()
  const [siderCollapsed, setSiderCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
    return window.matchMedia('(max-width: 991px)').matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia('(max-width: 991px)')
    const handler = (e) => setIsMobile(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  if (loading) return <div>Cargando...</div>

  // El portal de clientes es completamente independiente, sin navbar ni layout admin
  if (location.pathname === '/portal') {
    return <ClientPortal />
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {user && <Navbar />}
      {user && (
        <Layout style={{ marginTop: 52, background: '#0d0d0d', minHeight: 'calc(100vh - 52px)' }}>
          {!isMobile && <AdminSider collapsed={siderCollapsed} onCollapse={setSiderCollapsed} />}
          <Content style={{ padding: isMobile ? '12px' : '16px', background: '#0d0d0d', minHeight: 'calc(100vh - 52px)', overflow: 'hidden' }}>
            <Routes>
              <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/clients" element={<PrivateRoute><Clients /></PrivateRoute>} />
              <Route path="/usuarios" element={<PrivateRoute><Usuarios /></PrivateRoute>} />
              <Route path="/payments" element={<PrivateRoute><Payments /></PrivateRoute>} />
              <Route path="/classes" element={<PrivateRoute><Classes /></PrivateRoute>} />
              <Route path="/attendance" element={<PrivateRoute><Attendance /></PrivateRoute>} />
              <Route path="/whatsapp" element={<PrivateRoute><WhatsAppConfig /></PrivateRoute>} />
              <Route path="/rutinas" element={<PrivateRoute><Rutinas /></PrivateRoute>} />
              <Route path="/objetivos" element={<PrivateRoute><Objetivos /></PrivateRoute>} />
              <Route path="/progreso" element={<PrivateRoute><Progreso /></PrivateRoute>} />
              <Route path="/reportes" element={<PrivateRoute><Reportes /></PrivateRoute>} />
              <Route path="/mensajes" element={<PrivateRoute><Mensajes /></PrivateRoute>} />
              <Route path="/bienestar" element={<PrivateRoute><Bienestar /></PrivateRoute>} />
              <Route path="/configuracion" element={<PrivateRoute><Configuracion /></PrivateRoute>} />
              <Route path="/" element={<Navigate to="/portal" replace />} />
            </Routes>
          </Content>
        </Layout>
      )}
      {!user && (
        <Content style={{ padding: '12px', background: '#0d0d0d', minHeight: '100vh' }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<ClientPortal />} />
            <Route path="/" element={<Navigate to="/portal" replace />} />
            <Route path="*" element={<Navigate to="/portal" replace />} />
          </Routes>
        </Content>
      )}
      <Footer style={{ textAlign: 'center', padding: '12px', background: '#0d0d0d', color: '#555' }}>
        <div style={{ color: '#999', fontSize: 13, marginBottom: 4 }}>Desarrollado por <a href="https://www.instagram.com/impulsoweb.pv?igsh=NTNjYXM4ZWdoY3B3" target="_blank" rel="noopener noreferrer" style={{ color: '#E0B34A', textDecoration: 'none', fontWeight: 600 }}>Impulso Web PV</a></div>
        <div style={{ color: '#555', fontSize: 11 }}>© 2026 <a href="https://www.instagram.com/impulsoweb.pv?igsh=NTNjYXM4ZWdoY3B3" target="_blank" rel="noopener noreferrer" style={{ color: '#E0B34A', textDecoration: 'none' }}>Impulso Web PV</a></div>
      </Footer>
    </Layout>
  )
}

function App() {
  return (
    <ConfigProvider
      locale={esES}
      theme={{
        token: {
          colorPrimary: '#ffffff',
          colorBgBase: '#1a1a1a',
          colorTextBase: '#ffffff',
          colorBgContainer: '#2a2a2a',
          colorBorder: '#444',
          colorBgElevated: '#333',
          borderRadius: 8
        },
        algorithm: theme.darkAlgorithm
      }}
    >
      <AuthProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  )
}

export default App
